/**
 * Changelog — รายการอัปเดตระบบ (ใหม่สุดอยู่บนสุดเสมอ).
 * เพิ่ม entry ใหม่ไว้ "บนสุด" ทุกครั้งที่ ship ของใหม่ → widget มุมซ้ายล่างจะโชว์
 * วันที่ล่าสุดให้อัตโนมัติ + เด้งจุดแดงเตือนผู้ใช้ที่ยังไม่เปิดดู.
 */
export interface ChangelogEntry {
  /** YYYY-MM-DD (วันที่ปล่อยอัปเดต) */
  date: string;
  items: string[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    date: '2026-10-21',
    items: [
      'หัวหน้างานกด "ดูรายละเอียด" จากการ์ดใบลาในไลน์ แล้วเห็นใบลาของลูกทีมครบ อนุมัติ/ไม่อนุมัติได้ในหน้านั้น (เดิมหัวหน้าที่บัญชีเป็นพนักงานทั่วไปเห็น ใบลา (0)) · การ์ดใบลาในไลน์บอกวันที่ลาด้วยแล้ว',
    ],
  },
  {
    date: '2026-10-20',
    items: [
      'รับรองเวลาเข้า-ออกงาน อนุมัติ 2 ขั้นเหมือนใบลา — พนักงานที่มีหัวหน้า คำขอจะไปถึงหัวหน้าก่อน (แจ้งทาง LINE พร้อมลิงก์) หัวหน้าอนุมัติแล้วค่อยส่งต่อให้ HR รับรองขั้นสุดท้าย · พนักงานที่ไม่มีหัวหน้า ส่งถึง HR ตรงเหมือนเดิม · หน้าอนุมัติบอกว่าใบไหนอยู่ขั้นไหน',
    ],
  },
  {
    date: '2026-10-01',
    items: [
      'อนุมัติคำขอ → แท็บ "ย้ายวันหยุด" แสดงคำขอสลับวันหยุดกับเพื่อนด้วยแล้ว (เดิมขึ้นแค่คำขอย้ายวันหยุดของตัวเอง ทำให้เห็น 0 ทั้งที่มีคำขอรอ) · กดอนุมัติ/ไม่อนุมัติได้ในหน้าเดียว ระบบสลับกะในตารางให้ทั้งสองคน',
      'สิทธิ์ลาพักร้อน: พนักงานที่ทำงานครบ 1 ปีระหว่างปี ได้สิทธิ์พักร้อนของปีนั้นแล้ว (เดิมได้ 0 ทั้งปีจนถึงปีถัดไป ทำให้ขึ้น "เกินสิทธิ์") · ยื่นลาพักร้อนได้ตั้งแต่วันที่ครบ 1 ปีเป็นต้นไป',
    ],
  },
  {
    date: '2026-08-14',
    items: [
      'เมนูใหม่ "รับรองเวลาเข้างาน" — พนักงานที่ลืมสแกน/สแกนผิดเวลา/เน็ตหลุด ยื่นขอลงเวลาย้อนหลังเองได้ แล้ว HR กดรับรองที่หน้าอนุมัติ (แท็บ "รับรองเวลา") อนุมัติแล้วระบบบันทึกเป็นเวลาเข้า-ออกงานของวันนั้น พร้อมแจ้งผลกลับทาง LINE',
      'HR ลงเวลาย้อนหลังให้พนักงานเองได้ — ในหน้า "ประวัติเข้างานรายคน" เลือกพนักงาน วันที่ รอบ และเวลา พร้อมเหตุผล ระบบแจ้งพนักงานทาง LINE ทุกครั้ง และบันทึกในประวัติการใช้งานระบบ',
      'งวดที่ปิดงวด/จ่ายเงินแล้ว จะลงเวลาย้อนหลังไม่ได้ — กันหลักฐานเวลาไม่ตรงกับเงินที่จ่ายไปแล้ว',
    ],
  },
  {
    date: '2026-07-27',
    items: [
      'ขอลาคร่อมวันหยุดได้แล้ว — เดิมถ้าช่วงที่ลามีวันหยุด/วันหยุดประจำสัปดาห์ปนอยู่ ระบบจะไม่รับทั้งใบ ตอนนี้ระบบข้ามวันหยุดให้เอง บันทึกเฉพาะวันทำงาน และบอกว่าข้ามวันไหนไปบ้าง',
      'พนักงานที่หยุดไม่ตรงกับวันหยุดบริษัท (ยึดตารางเวร) ยื่นลาในวันที่บริษัทหยุดแต่ตัวเองต้องทำงานได้แล้ว',
      'หน้า "ประวัติเข้างานรายคน": เพิ่มปุ่มดาวน์โหลดรายงานเวลาเข้า-ออกทั้งบริษัทเป็นไฟล์ CSV — ทุกคน ทุกวัน (เข้ากี่โมง ออกกี่โมง สายกี่นาที ลา/ขาด) พร้อมสรุปรายคนเทียบกับตัวเลขที่ระบบใช้คิดเงิน',
      'ตาราง "สิทธิ์และการใช้วันลารายคน": โชว์วันลาคงเหลือของแต่ละคนแล้ว (เดิมเห็นแค่ใช้ไปกี่วัน)',
      'หน้า "สรุปการอนุมัติ": แยกให้เห็นว่ามาสาย/ขาดงานที่ยังไม่จัดการเหลือกี่รายการ + อธิบายว่าการกด "ปิด" ที่หน้ากิจกรรมผิดปกติไม่ได้เปลี่ยนยอดขาดงาน/เงินเดือน (ต้องกด "มาทำงานปกติ/บันทึกเป็นลา" แล้วรันสรุปเวลาใหม่)',
      'เพิ่มแท็บ "คำขอเริ่มงานใหม่" ในหน้าพนักงาน — ฝ่ายบุคคลยื่นคำขอรับพนักงานใหม่ให้เจ้าของอนุมัติก่อน อนุมัติแล้วระบบสร้างพนักงานให้อัตโนมัติ',
    ],
  },
  {
    date: '2026-07-16',
    items: [
      'หน้า "สรุปการอนุมัติ" (เดิมชื่อ "สรุปอนุมัติรายเดือน"): เพิ่มมุมมอง "รายปี" — เห็นยอดลา/OT/สาย/ขาด ทั้งปี แยกให้ทีละเดือน (แตะที่เดือนเพื่อเจาะดูรายละเอียด) + ดึง report ทั้งปีเป็นไฟล์ CSV ได้',
      'แก้: หน้าสรุปการอนุมัติเคยนับได้สูงสุดแค่ 1,000 รายการต่อเดือน — เดือนที่มีมาสาย/ขาดงานเยอะ ตัวเลขและสรุปรายคนจะขาดหายไปเงียบๆ ตอนนี้นับครบทุกรายการแล้ว',
    ],
  },
  {
    date: '2026-06-30',
    items: [
      'เพิ่มประเภทค่าจ้าง "รายชั่วโมง" — ตั้งเรท/ชม. ที่ข้อมูลพนักงาน แล้วกรอกชั่วโมงทำงานแต่ละงวดในหน้าทำเงินเดือน (กดดูรายละเอียดคนนั้น) · ค่าจ้าง = เรท × ชั่วโมง',
      'เบี้ยขยันขั้นบันได: เพิ่มโหมด "เด้งกลับขั้น 1 + ได้ 0 บาท" เมื่อมีสาย/ขาด/ลา (แทนลดทีละขั้น) + ตั้งเงื่อนไข "ต้องเข้าก่อนกะ N นาที" ได้',
    ],
  },
  {
    date: '2026-06-29',
    items: [
      'เพิ่มเมนู "สรุปอนุมัติรายเดือน" — ดูลา/OT ที่อนุมัติแล้ว + มาสาย/ขาดงาน ของทั้งเดือนในหน้าเดียว เลือกเดือนได้ พร้อมสรุปรายคน (ทบทวนก่อนปิดรอบเงินเดือน)',
      'แก้: ปุ่ม "แนบไฟล์" ในกล่องแจ้งปัญหา แนบไฟล์เอกสาร (PDF/Word/Excel/CSV) ได้แล้ว เดิมเลือกได้แค่รูป/วิดีโอ',
      'หน้า "เข้างานวันนี้": เพิ่มช่องค้นหาพนักงาน (พิมพ์ชื่อ/ชื่อเล่น/รหัส) กรองทุกแท็บ ไม่ต้องเลื่อนทีละคน',
      'หน้ารายชื่อพนักงาน: ขึ้นแบนเนอร์ "มีพนักงาน N คนยังไม่ตั้งเงินเดือน → ตั้งเลย" หาปุ่มตั้งเงินเดือนง่ายขึ้น (เดิมหาไม่เจอ)',
      'แก้: HR ที่ไม่มีสิทธิ์ตั้งเงินเดือน เปิดพนักงานแล้วเห็นคำอธิบายว่าต้องให้เจ้าของเปิดสิทธิ์ให้ (เดิมช่องหายเงียบ ดูเหมือนใส่เงินเดือนไม่ได้)',
    ],
  },
  {
    date: '2026-06-27',
    items: [
      'เพิ่มเมนู "ขอย้ายวันหยุด" — พนักงานสลับวันหยุดเอง อนุมัติแล้วระบบจัดเวรให้อัตโนมัติ',
      'แก้กะดึกข้ามวัน (เช่น 23:00–08:00) เข้า/ออกไม่สลับกันแล้ว',
      'นำเข้าตารางเวร: ตั้งเป็นเดือนหน้าให้อัตโนมัติ + แจ้งเดือนปลายทางชัด กันลงผิดเดือน',
      'นำเข้าเวร: ตั้งโหมด "ตารางเวร" ให้อัตโนมัติ (วันทำงานไม่โดนวันหยุดบริษัททับ)',
      'กันลงเวรทำงานทับวันลาที่อนุมัติแล้ว + ไฟล์ตารางเวรโชว์ป้ายวันลา',
      'พนักงานลาออกแล้ว ชื่อหายจากปฏิทินเวรอัตโนมัติ',
      'HR สิทธิ์เต็มจัดการเงินเดือนได้ (เดิมทำได้เฉพาะเจ้าของ)',
    ],
  },
];

/** entry ล่าสุด (ใหม่สุด) */
export const LATEST_CHANGE: ChangelogEntry | undefined = CHANGELOG[0];

const TH_MONTHS_SHORT = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
const TH_MONTHS_FULL = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];

/** "2026-06-27" → "27 มิ.ย. 69" (สั้น สำหรับ badge) */
export function thaiDateShort(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${TH_MONTHS_SHORT[m - 1]} ${(y + 543) % 100}`;
}

/** "2026-06-27" → "27 มิถุนายน 2569" (เต็ม สำหรับหัวข้อใน popup) */
export function thaiDateFull(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${TH_MONTHS_FULL[m - 1]} ${y + 543}`;
}
